"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findHotProbsMarkets = findHotProbsMarkets;
function findHotProbsMarkets(markets, hotMarketOutcomeTypeCodes) {
    return markets.reduce((acc, market) => {
        if (hotMarketOutcomeTypeCodes[market.name]) {
            acc[market.id] = {
                orderedOutcomeTypeIds: hotMarketOutcomeTypeCodes[market.name],
                market,
                hotProbabilityMarketType: market.name,
            };
        }
        return acc;
    }, {});
}
//# sourceMappingURL=findHotProbsMarkets.js.map